export default __webpack_public_path__ + "static/media/food_white.09a7f430.svg";